import React from "react";
import Navbar from "../Navbar/Navbar";
import { ArrowLongRightIcon, PlayCircleIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import TrustedBy from "./TrustedBy";

const Hero = () => {
  return (
    <>
      <Navbar />
      <section className="relative min-h-screen flex items-center bg-white overflow-hidden">
        {/* Subtle grid background */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px),linear-gradient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_110%)]" />
        
        {/* Gradient orbs */}
        <div className="absolute top-20 right-1/4 w-[500px] h-[500px] bg-blue-400/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-1/4 w-[400px] h-[400px] bg-indigo-400/10 rounded-full blur-3xl" />

        <div className="relative z-10 px-6 mx-auto lg:px-16 max-w-7xl w-full pt-32 pb-20 lg:pt-40 lg:pb-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            {/* Left content */}
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 rounded-full mb-8 border border-blue-100">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#0186ef] opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-[#0186ef]"></span>
                </span>
                <span className="text-sm font-medium text-[#0186ef]">Devdesk Pool live &middot;</span>
              </div>

              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 leading-[1.1] tracking-tight">
                We are your
                <span className="relative inline-block mx-2">
                  <span className="relative z-10 text-[#0186ef]">Partner</span>
                  <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 12" fill="none">
                    <path d="M2 8C50 2 150 2 198 8" stroke="#0186ef" strokeWidth="3" strokeLinecap="round" opacity="0.3"/>
                  </svg>
                </span>
                in digital transformation.
              </h1>

              <p className="mt-8 text-lg lg:text-xl text-gray-500 leading-relaxed max-w-lg">
                DevDesk is an innovative cloud-based integrated studio building digital
                human capital software for businesses. We provide end-to-end services
                that enable businesses and personal brands to accelerate their processes,
                manage change and build networks that foster growth.
              </p>

              <div className="mt-10 flex flex-col sm:flex-row gap-4">
                <Link
                  to="/products/pool"
                  className="inline-flex items-center justify-center px-7 py-3.5 text-base font-semibold text-white bg-[#0186ef] rounded-xl hover:bg-[#0070d0] transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 hover:-translate-y-0.5 group"
                >
                  Explore Our Product
                  <ArrowLongRightIcon className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center px-7 py-3.5 text-base font-semibold text-gray-700 bg-gray-50 border border-gray-200 rounded-xl hover:bg-gray-100 hover:border-gray-300 transition-all duration-300 group"
                >
                  <PlayCircleIcon className="mr-2 w-5 h-5 text-[#0186ef]" />
                  Schedule a Demo
                </Link>
              </div>

            </div>

            {/* Right visual - Human image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.stockcake.com/public/0/0/a/00a0a503-9f5c-4659-afd8-9775914b4653_large/focused-coding-session-stockcake.jpg"
                  alt="Software professional at work"
                  className="w-full h-[500px] lg:h-[600px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/40 via-transparent to-transparent" />
              </div>

              {/* Floating badge */}
              <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl shadow-xl px-5 py-3 border border-gray-100">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#0186ef]/10 rounded-xl flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#0186ef]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-900">Multi-Platform</div>
                    <div className="text-xs text-gray-500">POS, iOS, Android, Web</div>
                  </div>
                </div>
              </div>

              {/* Floating badge top right */}

            </div>
          </div>

          {/* Client logos */}
          <TrustedBy />
        </div>
      </section>
    </>
  );
};

export default Hero;
